// extracted by mini-css-extract-plugin
export default {"dot_indicator":"style_dot_indicator__o34F5","header_text":"style_header_text__XyRfj"};